<div class="form-row">
  <div class="form-group col-sm-12">
    <label><b>Selecionar Arquivo:</b></label>

    <input class="form-control form-control-sm" type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" #arquivo />

    <div class="mensagem pt-1">* Extensão XLSX</div>
    <div class="mensagem pt-1">* Primeira linha como cabeçalho</div>
    <div class="mensagem pt-1">* Cabeçalho com mesma nomenclatura do exemplo disponível p/ download</div>
  </div>
</div>

<hr class="mt-2 mb-2" />

<div class="d-flex flex-wrap justify-content-end">
  <div class="flex-grow-1 text-right">
    <a class="btn btn-link" href="../../../assets/download/importacoes/produtos.xlsx" download>Download Cabeçalho</a>
    <button class="btn btn-success btn_formulario" type="button" (click)="processar()">Processar</button>
  </div>
</div>

<hr class="mt-2 mb-2" />

@if (arquivoProcessado) {
  <div>
    @if (importacoesErros.length > 0) {
      <div class="table-responsive">
        <cdk-virtual-scroll-viewport class="tabela_lg" [itemSize]="20">
          <table class="table table-sm table-hover">
            <thead>
              <tr>
                <th class="text-center">Linha</th>
                <th class="tabela_borda text-center">Coluna</th>
                <th class="tabela_borda">Erro</th>
                <th class="tabela_borda">Mensagem</th>
              </tr>
            </thead>
            <tbody>
              <tr *cdkVirtualFor="let importacaoErro of importacoesErros; templateCacheSize: 0;">
                <td class="text-center">{{ importacaoErro.linha }}</td>
                <td class="tabela_borda text-center">{{ importacaoErro.coluna }}</td>
                <td class="tabela_borda">{{ importacaoErro.erro }}</td>
                <td class="tabela_borda">{{ importacaoErro.mensagem }}</td>
              </tr>
            </tbody>
          </table>
        </cdk-virtual-scroll-viewport>
      </div>
    }
    @if (importacoesErros.length == 0 && produtos.length > 0) {
      <div>
        <div class="quadro_mensagem text-center p-2">
          <h6 class="tabela_mensagem_inferior"><b>Nenhum erro localizado!</b></h6>
          <h6 class="tabela_mensagem_inferior"><b>Produtos a serem importados: {{ produtos.length }}</b></h6>
          <h6 class="tabela_mensagem_inferior"><b>Para prosseguir clique em 'Importar'...</b></h6>
        </div>
        <hr class="mt-2 mb-2" />
        <div class="d-flex flex-wrap justify-content-end">
          <div class="flex-grow-1 text-right">
            <button class="btn btn-success btn_formulario" type="button" (click)="importar()">Importar</button>
          </div>
        </div>
      </div>
    }
  </div>
}
